<header-tabs [routes]="routes"></header-tabs>

<router-outlet></router-outlet> 